import { render, staticRenderFns } from "./UsersListItem.vue?vue&type=template&id=b8b3924a&lang=pug"
import script from "./UsersListItem.vue?vue&type=script&lang=js"
export * from "./UsersListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports